import $ from 'jquery'

import apiUrl from 'base/api_url'
import routeTo from 'base/lib/route_to'
import { error } from 'base/lib/console'
import getQueryParam from 'base/lib/get_query_param'

import Hub from 'base/hub'
import Event from 'base/event'
import store from 'base/store'
import addLineItem from 'base/actions/add_line_item'

const transformVariantData = variantData => ({
  id: variantData.variant_id,
  size: variantData.size,
  sku: variantData.sku,
})

const addToBag = async (permalink, size) => {
  const [product] = await $.getJSON(apiUrl('products'), {
    permalinks: permalink,
  })
  const variantData = product.variants.find(variant =>
    [variant.size, variant.size.toUpperCase()].includes(size),
  )

  if (!variantData) {
    const possibleSizes = product.variants.map(v => v.size)
    error(`Could not find size '${size}' in variants of size ${possibleSizes}`)
    return
  }

  const variant = transformVariantData(variantData)

  const existingLineItem = store
    .getState()
    .cart.line_items?.find(
      lineItem => lineItem.abbreviated_size === size && lineItem.product_permalink === permalink,
    )

  if (!existingLineItem) {
    store
      .dispatch(
        addLineItem({
          variant,
          product,
        }),
      )
      .then(() => routeTo('/checkout', { hard: true }))
  }
}

Hub.sub(Event.App.LAND, () => {
  const permalink = getQueryParam('add_to_bag_permalink')
  const size = getQueryParam('add_to_bag_size')
  if (permalink && size) {
    addToBag(permalink, size)
  }
})
